import {
  Component,
  Injectable,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import * as fromApp from './store/app.reducer';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { NavController } from '@ionic/angular';
import { AuthService } from './services/auth.service';
import { CRUDAction, PermissionType } from './core/enums';
import { AuthModel } from './core/models/auth.model';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { TranslationService } from './services/translation.service';
import { DialogService } from './services/dialog.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import * as AuthActions from './store/actions/auth.actions';
import * as AuthSelectors from './store/selectors/auth.selector';
import { HttpClient } from '@angular/common/http';
import { UserService } from './services/user.service';
import { UserModel } from './core/models/user.model';

@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  toggle: boolean;
  recieveEmail: boolean;
  helpUrl;
  hasSecurityAccess: boolean;
  hasOtherCataloguesAccess: boolean;
  hasCatalogAccess: boolean;
  hasAdvancedSearchAccess: boolean;
  hasReportAccess: boolean;
  hasParcelAccess: boolean;
  hasPolitikiGiAccess: boolean;
  hasBuildingAccess: boolean;
  hasAuditPropsAccess: boolean;
  hasMapAccess: boolean;
  hasE9Access: boolean;
  hasStoixeiaPoleodomiasAccess: boolean;
  hasSettlementDeedsAccess: boolean;

  firstPathSegment: string;
  hasParcelAccessUpdate: boolean;
  hasParcelAccessDelete: boolean;
  hasMapAccesss: boolean;
  hasBasicCharacteristicsAccess: boolean;
  hasTechnicalFeaturesAccess: boolean;
  hasBenefitsAccess: boolean;
  hasUrbanFeaturesAccess: boolean;
  hasEconomicDataAccess: boolean;
  hasSalesFeaturesAccess: boolean;
  hasPolitikiGiAccessDelete: boolean;
  hasPolitikiGiAccessUpdate: boolean;
  hasPolitikiGiAccessCreate: boolean;

  isUserLoaded = false;

  currentUserId!: number;
  currentUser!: UserModel;    // διαθέσιμη παντού μέσα στο component


  selectedValue: string | undefined;

  language = new FormControl('el');
  isTaxisConfig = false;
  dashboardOnConfig = false;
  versionUi: string;
  versionApi: string;
  versionDb: string;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private store: Store<fromApp.AppState>,
    private navController: NavController,
    private authService: AuthService,
    private translationService: TranslationService,
    public dialogService: DialogService,
    private router: Router,
    private http: HttpClient,
    private userService: UserService
  ) { }

  async logInOidcUser(email, password) {
    this.store.dispatch(
      AuthActions.loginStart({
        payload: {
          email,
          password,
        },

      })
    );
    return;
  }

  onSelectChange(ev: any) {
    // δύο εναλλακτικές για να πάρεις το αποτέλεσμα
    const newFirstPage = this.selectedValue;

    const updatedUser = { ...this.currentUser } as UserModel;
    updatedUser.firstpage = newFirstPage;

    this.userService.updateUser(updatedUser).subscribe({
      next: () => {

        this.currentUser.user = updatedUser;
        this.selectedValue = ev.detail.value;


        localStorage.setItem('firstpage', this.selectedValue);
      },
      error: (err) => {
        console.error('UpdateUser failed', err);

      },
    });
  }

  async signUpOidcUser(first_name, last_name, email, password) {

    this.store.dispatch(
      AuthActions.signupStart({
        payload: {
          first_name,
          last_name,
          email,
          password,
        },
      })
    );

    return;
  }

  ngOnInit() {

    this.http.get<{ dashboardOn: boolean }>('assets/config/config.json').subscribe((config) => {
      this.dashboardOnConfig = config.dashboardOn;
    }
    );
    this.http.get<{ isTaxis: boolean }>('assets/config/config.json').subscribe((config) => {
      this.isTaxisConfig = config.isTaxis;
      if (!!this.isTaxisConfig) {
        let autheticatedByOidc = false;
        this.oidcSecurityService.checkAuth().toPromise().then(async ({ isAuthenticated, userData }) => {
          autheticatedByOidc = !!isAuthenticated;
          if (!autheticatedByOidc) {
            return;
          }


          this.signUpOidcUser(userData['given_name'], userData['family_name'], userData['email'], 'Zc3!gHt5RhTxveWpPcEwQ4O0o')
            .finally()
            .then(() => {
              this.store
                .select(AuthSelectors.selectSignUpCompletion)
                .pipe(filter((x) => x === true))
                .subscribe((signUpCompleted) => {
                  this.logInOidcUser(userData['email'], 'Zc3!gHt5RhTxveWpPcEwQ4O0o');
                });
            });
        });
      }
    });

    const hostname = window.location.hostname;
    if (hostname === 'vps.geospatial.net.gr') {
      const pathname = window.location.pathname;

      // Κάνει split και φιλτράρει τυχόν κενά strings
      const segments = pathname
        .split('/')          // ["", "home", "whatever"]
        .filter(segment => segment.length > 0);  // ["home", "whatever"]

      // Παίρνει πάντα το πρώτο στοιχείο ή undefined αν είναι βασικό /
      const firstSegment = segments[0] || '';
      const oldFisrstSegment = localStorage.getItem('firstPathSegment');

      if (oldFisrstSegment !== firstSegment) {
        localStorage.setItem('firstPathSegment', firstSegment);
        this.authService.logoutUser();
        if (this.isTaxisConfig === true) {
          this.oidcSecurityService.logoff();
        }
      };
    }



    if (localStorage.getItem('landify2-darktheme') === 'true') {
      this.toggle = true;
      document.body.classList.toggle('custom-mat-dark-theme');
      document.body.setAttribute('color-theme', 'dark');
    } else {
      document.body.setAttribute('color-theme', 'light');
    }

    this.helpUrl = environment.helpUrl;

    const savedLanguage = localStorage.getItem('appLanguage') || 'el';
    this.language.setValue(savedLanguage);
    this.translationService.setLanguage(savedLanguage);

    this.language.valueChanges.subscribe((value) => {
      localStorage.setItem('appLanguage', value);
      this.translationService.setLanguage(value);
    });


    this.authService
      .getActiveUser()
      .pipe(
        filter((u): u is AuthModel => !!u),
        take(1),
        switchMap((u) =>
          this.userService.readUserById(u.id).pipe(

            map((res) => res.data)
          )
        )
      )
      .subscribe({
        next: (user) => {
          this.currentUser = user;
          this.isUserLoaded = true;
          this.recieveEmail = this.currentUser.user.recieveemail
          console.log("recieveEmail", this.recieveEmail)
          this.selectedValue = String(this.currentUser.user.firstpage);
          console.log("selectedValue", this.selectedValue)
          localStorage.setItem('firstpage', this.selectedValue);
          const versionOptionUI = this.currentUser.product_options.find(
            (opt: any) => opt.option_code === 'VERSION_UI'
          );
          const versionOptionAPI = this.currentUser.product_options.find(
            (opt: any) => opt.option_code === 'VERSION_API'
          );

          const versionOptionDB = this.currentUser.product_options.find(
            (opt: any) => opt.option_code === 'VERSION_DB'
          );

          this.versionUi = versionOptionUI ? versionOptionUI.option_value : null;
          this.versionApi = versionOptionAPI ? versionOptionAPI.option_value : null;
          this.versionDb = versionOptionDB ? versionOptionDB.option_value : null;


        },
        error: (err) => console.error('Δεν μπόρεσα να φορτώσω τον χρήστη', err),
      });

    this.authService
      .getActiveUser()
      .pipe(filter((x) => !!x))
      .subscribe((x: AuthModel) => {
        this.hasSecurityAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2000
        );
        this.hasCatalogAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2001
        );
        this.hasAdvancedSearchAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2002
        );
        this.hasReportAccess = this.authService.getPermission(
          x.role,
          PermissionType.Module,
          1006,
          CRUDAction.Read
        );
        this.hasParcelAccess = this.authService.getPermission(
          x.role,
          PermissionType.Module,
          1002,
          CRUDAction.Create
        );
        this.hasBuildingAccess = this.authService.getPermission(
          x.role,
          PermissionType.Module,
          1003,
          CRUDAction.Create
        );
        this.hasMapAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2005
        );
        this.hasOtherCataloguesAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2006
        );
        this.hasE9Access = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2007
        );
        this.hasStoixeiaPoleodomiasAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2008
        );
        this.hasSettlementDeedsAccess = this.authService.getPermission(
          x.role,
          PermissionType.Page,
          2009
        );
      });
  }

  toggleTheme(event) {
    if (event.detail.checked) {
      document.body.setAttribute('color-theme', 'dark');
    } else {
      document.body.setAttribute('color-theme', 'light');
    }

    document.body.classList.toggle('custom-mat-dark-theme');
    localStorage.setItem('landify2-darktheme', this.toggle.toString());
  }

  toggleRecieveEmail(event) {
    const updatedUser = { ...this.currentUser } as UserModel;

    updatedUser.recieveemail = event.detail.checked;

    this.userService.updateUser(updatedUser).subscribe({
      next: () => {
      },
      error: (error) => {
        console.error('Failed to update user:', error);
      }
    });
  }

  async changePage(path: string) {
    if (this.router.url.includes('/parcels')
      || this.router.url.includes('/buildings')
      || this.router.url.includes('/security/users/')
      || this.router.url.includes('/security/roles/')
      || this.router.url.includes('/e9')
      || this.router.url.includes('/settlement-deeds')
    ) {
      const result = await this.dialogService.confirmationAlert(
        this.translationService.translate(
          'COMMON.PENDING_CHANGES_CONFIRMATION_GENIC'
        )
      );
      if (result === false) return;
    }
    this.navController.navigateBack(path);
  }

}
